export default "__VITE_ASSET__B9pS5HrU__"